var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDownOutline = function SvgDownOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8725762,2.41509434 C92.2770083,0.603773586 90.1495845,0 88.0221607,0 L8.24376731,0.603773586 C6.11634349,0.603773586 3.98891966,1.20754717 2.39335181,3.01886792 C-0.797783935,6.64150944 -0.797783935,12.0754717 2.39335181,15.6981132 L42.2825485,60.981132 C42.2825485,60.981132 42.2825485,60.981132 42.2825485,60.981132 C42.2825485,60.981132 42.2825485,60.981132 42.2825485,60.981132 C42.8144045,61.5849056 43.8781163,62.1886792 44.4099723,62.7924528 C44.4099723,62.7924528 44.9418283,63.3962264 44.9418283,63.3962264 C47.601108,64.6037736 51.3240997,64 53.4515235,61.5849056 L93.3407202,15.6981132 C97.0637119,11.4716981 96.531856,6.03773586 93.8725762,2.41509434 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDownOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "down-outline.c23f2ceded75144935386cda1273fb11.svg";